// src/pages/PrivacyPolicy.js 
// (Assuming this file contains your PrivacyPolicy component)

import React from 'react';
import { Helmet } from 'react-helmet-async'; // 👈 Import the Helmet component

// Common Components
import Navbar from '../../CommonComponent/Navbar/Navbar'; 
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';

// Page Component
import PPcontent from './PageComponent/PPcontent';

function PrivacyPolicy() {

    // The useMeta hook call is removed and its content is moved into <Helmet>
    return (
        <>
            <Helmet>
                {/* Primary SEO Tags */}
                <title>Privacy Policy | Marvel Blinds</title>
                <meta
                    name="description"
                    content="Your privacy matters to us. Learn how we handle your data and keep it safe. Review our privacy policy for full transparency."
                />
                <link rel="canonical" href={`${process.env.REACT_APP_WEBSITE_URL}/privacy-policy/`} />

                {/* Open Graph Tags (for Social Media) */}
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="article" />
                <meta property="og:title" content="Privacy Policy" />
                <meta
                    property="og:description"
                    content="Your privacy matters to us. Learn how we handle your data and keep it safe. Review our privacy policy for full transparency."
                />
                <meta property="og:url" content={`${process.env.REACT_APP_WEBSITE_URL}/privacy-policy/`} />
                <meta property="og:site_name" content="Marvel Blinds" />
            </Helmet>

            {/* Rest of your component structure */}
            <div>
                <Navbar />
                <NotificationBar />
                <PPcontent />
                <Footer />
            </div>
        </>
    );
}

export default PrivacyPolicy;